export default __webpack_public_path__ + "static/media/avatar_11.2263db4a.png";